// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"CustomerWiseAPISalesPage_inputContainer__B8byL"};